export var DragTypes;
(function (DragTypes) {
    DragTypes["TILE"] = "TILE";
})(DragTypes || (DragTypes = {}));
export var TileVariant;
(function (TileVariant) {
    TileVariant["SINGLE"] = "singleTile";
    TileVariant["DOUBLE"] = "doubleTile";
    TileVariant["TRIPLE"] = "tripleTile";
})(TileVariant || (TileVariant = {}));
export const TileNames = {
    HvacOutliers: 'HVAC Outlier',
    EnergyInsightsCard: 'Power Demand',
    EquipmentIssuesCard: 'Equipment With Most Notifications',
    RecommendationsCard: 'Recommendations',
    PeriodComparisonCard: 'Energy Cost Trend',
    EnergyDistributionCard: 'Energy Distribution',
    EnergyFlowChartCard: 'Energy Flow',
    MajorIssuesCard: 'Notification Summary',
    EmissionsCard: 'CO₂ Emissions',
    Top5ConsumptionCard: 'Highest Consuming Type',
    Top5EquipmentEnergyConsumptionCard: 'Highest Consuming Equipment',
    TopConsumingSpacesCard: 'Highest Consuming Spaces',
    AmbientConditionsCard: 'Current Ambient Conditions',
    SitePeakDemandCard: 'Peak Demand Summary',
    ControlsSavingsCard: 'Controls Savings',
    EquipmentTemperatureComplianceCard: 'Equipment: Temperature Compliance',
    ControlsOverviewCard: 'Controls Overview',
    AmbientConditionsTemperatureCard: 'Ambient Temperature',
    AmbientConditionsHumidityCard: 'Ambient Humidity',
    TemperatureReviewCard: 'Temperature Review',
    DailyEnergyConsumptionCard: 'Daily Energy Consumption',
    SetpointRecommendationCard: 'Setpoint Recommendation',
    NonOperatingHourEfficiencyCard: 'Operating Hour (OH) vs Non-Operating Hour (NOH)',
};
export var Tiles;
(function (Tiles) {
    Tiles["HvacOutliersCard"] = "HvacOutliersCard";
    Tiles["MajorIssuesCard"] = "MajorIssuesCard";
    Tiles["EnergyDistributionCard"] = "EnergyDistributionCard";
    Tiles["EnergyInsightsCard"] = "EnergyInsightsCard";
    Tiles["EmissionsCard"] = "EmissionsCard";
    Tiles["Top5ConsumptionCard"] = "Top5ConsumptionCard";
    Tiles["RecommendationsCard"] = "RecommendationsCard";
    Tiles["PeriodComparisonCard"] = "PeriodComparisonCard";
    Tiles["EquipmentIssuesCard"] = "EquipmentIssuesCard";
    Tiles["Top5EquipmentEnergyConsumptionCard"] = "Top5EquipmentEnergyConsumptionCard";
    Tiles["TopConsumingSpacesCard"] = "TopConsumingSpacesCard";
    Tiles["AmbientConditionsCard"] = "AmbientConditionsCard";
    Tiles["SitePeakDemandCard"] = "SitePeakDemandCard";
    Tiles["ControlsSavingsCard"] = "ControlsSavingsCard";
    Tiles["EquipmentTemperatureComplianceCard"] = "EquipmentTemperatureComplianceCard";
    Tiles["ControlsOverviewCard"] = "ControlsOverviewCard";
    Tiles["AmbientConditionsTemperatureCard"] = "AmbientConditionsTemperatureCard";
    Tiles["AmbientConditionsHumidityCard"] = "AmbientConditionsHumidityCard";
    Tiles["TemperatureReviewCard"] = "TemperatureReviewCard";
    Tiles["DailyEnergyConsumptionCard"] = "DailyEnergyConsumptionCard";
    Tiles["SetpointRecommendationCard"] = "SetpointRecommendationCard";
    Tiles["NonOperatingHourEfficiencyCard"] = "NonOperatingHourEfficiencyCard";
    Tiles["AddTileCard"] = "AddTileCard";
})(Tiles || (Tiles = {}));
export var TileConfigurations;
(function (TileConfigurations) {
    TileConfigurations["Default"] = "Default";
})(TileConfigurations || (TileConfigurations = {}));
///*** Today Tile ***///
export const TodayTileNames = {
    ActiveIncidentCounts: 'Sites with Active Incidents',
    ActiveIncidentsOverview: 'Active Incidents Overview',
};
///*** Notifications Overview Tile ***///
export const NotificationsOverviewTileNames = {
    IncidentSummary: 'Incident Summary',
    DailyNotifications: 'Daily Notifications',
    SitesWithMostIncidents: 'Sites with Most Incidents',
    EquipmentWithMostIncidents: 'Equipment with Most Incidents',
    EquipmentTimeInIncidentState: 'Equipment Time in Incident State',
    IncidentsByPriority: 'Incidents by Severity',
};
